import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'

import { store } from 'store'

interface Props {
  element: JSX.Element
  [x: string]: any
}

export const AdminRoute = observer(({ element, ...rest }: Props): JSX.Element => {
  const { userStore } = store
  const { currentRole, userName } = userStore

  return userName && currentRole === 'ADMIN' ? element : <Navigate replace to='/' />
})
